export var MarketplaceIds;
(function (MarketplaceIds) {
    MarketplaceIds["US"] = "US";
    MarketplaceIds["CA"] = "CA";
    MarketplaceIds["ES"] = "ES";
    MarketplaceIds["FR"] = "FR";
    MarketplaceIds["IT"] = "IT";
    MarketplaceIds["DE"] = "DE";
    MarketplaceIds["UK"] = "UK";
})(MarketplaceIds || (MarketplaceIds = {}));
export const EU_MARKETPLACE_IDS = {
    FR: MarketplaceIds.FR,
    DE: MarketplaceIds.DE,
    IT: MarketplaceIds.IT,
    ES: MarketplaceIds.ES,
    UK: MarketplaceIds.UK,
};
export const MarketplaceToTopLevelDomain = {
    [MarketplaceIds.CA]: '.ca',
    [MarketplaceIds.US]: '.com',
    [MarketplaceIds.ES]: '.es',
    [MarketplaceIds.FR]: '.fr',
    [MarketplaceIds.IT]: '.it',
    [MarketplaceIds.DE]: '.de',
    [MarketplaceIds.UK]: '.co.uk',
};
/**
 * Returns the marketplace ID based on the search params or domain.
 * Priority: searchParams > domain-based detection > 'US' fallback
 */
export const getMarketplace = (searchParams) => {
    const marketplaceId = searchParams.get('marketplaceId');
    // Use tld detection if marketplaceId is invalid
    if (marketplaceId && marketplaceId in MarketplaceIds)
        return marketplaceId;
    const hostname = window.location.hostname;
    const entry = Object.entries(MarketplaceToTopLevelDomain).find(([_m, t]) => hostname.endsWith(t));
    return entry ? entry[0] : MarketplaceIds.US;
};
/**
 * Checks if the given marketplace is an EU marketplace
 */
export const isEUMarketplace = (marketplaceId) => {
    return marketplaceId in EU_MARKETPLACE_IDS;
};
